
import { Notification } from "@/hooks/useNotificationDetail";
import { SupabaseNotification } from "@/types/notifications";
import { logWebhookResult } from "./webhookLogger";
import { sendWebhook } from "./webhookUtils";

/**
 * Send a webhook to the Decoprof system when a notification status changes
 */
export const sendDecoprofWebhook = async (
  notification: Notification | SupabaseNotification,
  oldStatus?: string,
  isTest: boolean = false
): Promise<boolean> => {
  const webhookUrl = "https://luijtenvvz.app.n8n.cloud/webhook/Actie Decoprof Webhook";
  
  try {
    if (!notification || !notification.id) {
      console.error("Invalid notification data for webhook", notification);
      return false;
    }
    
    const payload = {
      melding_id: notification.id,
      vo_nummer: notification.vo_number,
      vo_nummer_origineel: notification.vo_number,
      exact_ordernummer: notification.exact_order_number,
      type: notification.type,
      oude_status: oldStatus || null,
      nieuwe_status: notification.status,
      prioriteit: notification.priority,
      gewijzigd_door: notification.user_name,
      timestamp: new Date().toISOString(),
      bericht_inhoud: notification.message,
      is_test: isTest,
      gearchiveerd: notification.archived
    };
    
    const result = await sendWebhook({
      webhookUrl,
      payload,
      webhookType: 'decoprof_status',
      entityId: notification.id,
      entityType: 'notification'
    });
    
    // If we get a successful response, log the webhook call
    if (result.success) {
      await logWebhookResult(
        notification,
        'decoprof_status',
        webhookUrl,
        payload,
        result.responseStatus,
        result.responseText,
        true
      );
    }
    
    return result.success;
  } catch (error) {
    console.error("Unexpected error in webhook service:", error);
    return false;
  }
};
